import { bool, func } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import DiscardableForm from '../../../generic/DiscardableForm';
import { contactListShape } from '../../../prop-types';

function ContactListForm({ model, onChange, onSubmit }) {
  const { name, description } = model;
  const inputProps = { onChange };

  return (
    <DiscardableForm onSubmit={onSubmit}>
      <Row>
        <Col>
          <FormGroup row>
            <Label sm={4} for="cl-name">
              Name
            </Label>
            <Col sm={8}>
              <Input
                id="cl-name"
                name="name"
                value={name || ''}
                {...inputProps}
              />
            </Col>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup row>
            <Label sm={4} for="cl-description">
              Description
            </Label>
            <Col sm={8}>
              <Input
                id="cl-description"
                name="description"
                value={description || ''}
                {...inputProps}
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </DiscardableForm>
  );
}

ContactListForm.propTypes = {
  model: contactListShape.isRequired,
  onChange: func,
  onSubmit: func,
  onDiscard: func,
  newModel: bool,
};

ContactListForm.defaultProps = {
  onChange: undefined,
  onSubmit: undefined,
  onDiscard: undefined,
  newModel: false,
};

export default ContactListForm;
